import { render, staticRenderFns } from "./PaymentHeaderComponent.vue?vue&type=template&id=578de26e"
import script from "./PaymentHeaderComponent.vue?vue&type=script&lang=js"
export * from "./PaymentHeaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_@vue+compiler-sfc@_21fabc512e5cf77502f11efea17f021f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports